<template>
  <div class="notes_content_body">
    <div class="notes_editor_container">
      <input
        :value="noteDetails.title"
        type="text"
        class="note_title_input readonly"
        readonly
      />
      <div class="readonly_content_area" v-html="noteDetails.data"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotesReadOnlyView',

  props: {
    noteDetails: {
      type: Object,
      default: () => ({ title: '', data: '' })
    }
  }
};
</script>

<style lang="scss" scoped>
$bg-surface: #18191f;
$border-color: #262933;
$text-secondary: #9096a6;

.notes_content_body {
  flex: 1;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.notes_editor_container {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding:5px 20px 20px;
  overflow: hidden;
  background: #0b0c10;

  .note_title_input.readonly {
    width: 100%;
    background: transparent;
    border: none;
    border-bottom: 1px solid transparent;
    font-size: 18px;
    font-weight: 600;
    color: $text-secondary;
    padding: 8px 0 12px 0;
    outline: none;
  }
}

.readonly_content_area {
  flex: 1;
  overflow-y: auto;
  line-height: 1.7;
  font-size: 14px;
  color: #cfd3dc;
  padding: 10px;
  background: $bg-surface;
  border: 1px solid $border-color;
  border-radius: 8px;
}
</style>